import React, { useEffect, useState, useRef } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import Sidebar from "../../component/Sidebar";
import Topbar from "../../component/Topbar";
import { baseurl } from "../../baseurl";
import axios from "axios";
import { FiArrowLeft, FiPrinter } from "react-icons/fi";

function Invoice() {
  const { order_uuid } = useParams();
  const vendorId = localStorage.getItem("vendorId");
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const invoiceRef = useRef();

  const fetchOrder = async () => {
    try {
      setLoading(true);
      const res = await axios.get(
        `${baseurl}getOrderDetailsForVendor/${vendorId}?order_uuid=${order_uuid}`
      );
      if (res.data.success) {
        setOrder(res.data.order);
      }
    } catch (err) {
      console.error("Error fetching order details:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (vendorId && order_uuid) fetchOrder();
  }, [vendorId, order_uuid]);

  const handlePrint = () => {
    window.print();
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-IN');
  };

  const formatInvoiceNo = (id) => {
    return `SCIM/25-26/${String(id).padStart(6, '0')}`;
  };

  const getOrderDate = () => {
    return formatDate(order?.created_at);
  };

  if (loading) return <div className="p-5 text-center">Loading Invoice...</div>;
  if (!order) return <div className="p-5 text-center text-danger">Order not found.</div>;

  return (
    <>
      <div className="d-print-none">
        <Topbar />
        <Sidebar />
      </div>

      <main className="main-wrapper p-3 p-lg-4" style={{ backgroundColor: "#f8f9fa", minHeight: "100vh" }}>
        
        {/* Action Bar */}
        <div className="container d-print-none mb-4 d-flex justify-content-between align-items-center">
          <button className="btn btn-light border shadow-sm" onClick={() => navigate(-1)}>
            <FiArrowLeft className="me-2" /> Back
          </button>
          <button className="btn btn-primary shadow-sm" onClick={handlePrint}>
            <FiPrinter className="me-2" /> Print Invoice
          </button>
        </div>

        {/* Main Invoice Sheet */}
        <div 
          ref={invoiceRef} 
          className="invoice-container printable-section"
        >
          {/* Header Section */}
          <div className="invoice-header">
            <div className="header-left">
              <div className="logo-section">
                <h1 className="company-name">SUBCITY</h1>
                <p className="tagline">SHOP MORE, PAY LESS</p>
              </div>
            </div>
            <div className="header-center">
              <h2 className="invoice-title">TAX INVOICE</h2>
              <p className="invoice-subtitle">(ORIGINAL FOR RECIPIENT)</p>
              <p className="invoice-note">(Issued under Section 31 of CGST Act, 2017)</p>
            </div>
            <div className="header-right">
              <table className="invoice-meta-table">
                <tbody>
                  <tr>
                    <td className="label">Invoice No.</td>
                    <td className="value">{formatInvoiceNo(order.order_id)}</td>
                  </tr>
                  <tr>
                    <td className="label">Invoice Date</td>
                    <td className="value">{formatDate(order.created_at)}</td>
                  </tr>
                  <tr>
                    <td className="label">Order No.</td>
                    <td className="value">{order.order_id}</td>
                  </tr>
                  {/* <tr>
                    <td className="label">Order Date</td>
                    <td className="value">{formatDate(order.created_at)}</td>
                  </tr>
                  <tr>
                    <td className="label">Place of Supply</td>
                    <td className="value">ASSAM (18)</td>
                  </tr>
                  <tr>
                    <td className="label">Reverse Charge</td>
                    <td className="value">No</td>
                  </tr> */}
                </tbody>
              </table>
            </div>
          </div>

          {/* Billing Section */}
          <div className="billing-section">
            <div className="billing-from">
              <h3 className="section-header">BILLING FROM</h3>
              
              <div className="billing-details">
                <p className="fw-bold">Subcity International Marketing Pvt Ltd</p>
                <p>Paliguri, Jagiroad, Morigaon,<br />Assam - 782410, India</p>
                <p>Mobile No.: 8876499739<br />GSTIN/UIN: 18AABCS1234M1ZP</p>
                {/* <p>State Code : 18 - ASSAM</p> */}
                <p>CIN: U74999AS2023PTC023456</p>
                <p>E-Mail: support@subcity.in</p>
              </div>
            </div>

            <div className="shipment-from">
              <h3 className="section-header">SHIPMENT FROM (VENDOR)</h3>
              <div className="shipment-details">
                <p className="fw-bold">{order.vendor?.name}</p>
                <p>{order.vendor?.address?.address_line1} {order.vendor?.address?.address_line2},
                  {order.vendor?.address?.city}, {order.vendor?.address?.state}, {order.vendor?.address?.country}, 
                  {order.vendor?.address?.postal_code}
                </p>
                <p>Mobile No.: {order.vendor?.phone}<br />GSTIN/UIN: {order.vendor?.gst_number}</p>
                {/* <p>State Code : 18 - ASSAM</p> */}
                <p>E-Mail: {order.vendor?.email}</p>
              </div>
            </div>
          </div>

          {/* Customer Details */}
          <div className="customer-section">
            <div className="billed-to">
              <h3 className="section-header">BILLED TO (CONSIGNEE)</h3>
              <div className="customer-details">
                <p className="fw-bold">{order.customer?.name}</p>
                <p>{order.shipping_details?.address}, {order.shipping_details?.city} {order.shipping_details?.pincode}, India</p>
                {/* <p>Assam - {order.shipping_details?.pincode}, India</p> */}
                {/* <p>State Code : 18 - ASSAM</p> */}
                {/* <p>Place of Supply : ASSAM</p> */}
                <p>Mobile No.: {order.shipping_details?.phone}</p>
              </div>
            </div>

            <div className="shipped-to">
              <h3 className="section-header">SHIP TO</h3>
              <div className="customer-details">
                <p className="fw-bold">{order.shipping_details?.fullName}</p>
                <p>{order.shipping_details?.address}, {order.shipping_details?.city} {order.shipping_details?.pincode}, India</p>
                {/* <p>Assam - {order.shipping_details?.pincode}, India</p> */}
                {/* <p>State Code : 18 - ASSAM</p> */}
                {/* <p>Place of Supply : ASSAM</p> */}
                <p>Mobile No.: {order.shipping_details?.phone}</p>
              </div>
            </div>
          </div>

          {/* Invoice Details */}
          {/* <div className="invoice-details">
            <p>Invoice Type: Regular | Supply Type: Inter-State Supply</p>
          </div> */}

          {/* Items Table */}
          <div className="items-table">
            <table>
              <thead>
                <tr>
                  <th>Sl. No.</th>
                  <th>Description of Goods / Services</th>
                  <th>HSN/SAC</th>
                  <th>Qty</th>
                  <th>Unit</th>
                  <th>Unit Price (₹)</th>
                  <th>Discount (₹)</th>
                  <th>Taxable Value (₹)</th>
                  <th colspan="2">SGST 9%</th>
                  <th colspan="2">CGST 9%</th>
                  <th>Total Amount (₹)</th>
                </tr>
                <tr>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th>Rate (%)</th>
                  <th>Amount (₹)</th>
                  <th>Rate (%)</th>
                  <th>Amount (₹)</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {order.items.map((item, idx) => (
                  <tr key={idx}>
                    <td>{idx + 1}</td>
                    <td className="item-name">
                      <div className="fw-bold">{item.product_name}</div>
                      {item.variant_json && (
                        <span className="item-variant">
                          {Object.entries(item.variant_json).map(([k, v]) => `${k}: ${v}`).join(", ")}
                        </span>
                      )}
                    </td>
                    <td>9042100</td>
                    <td className="text-center">{item.quantity}</td>
                    <td>Nos</td>
                    <td className="text-right">₹{Number(item.product_price).toLocaleString()}</td>
                    <td className="text-right">0.00</td>
                    <td className="text-right">₹{Number(item.product_price).toLocaleString()}</td>
                    <td>9%</td>
                    <td className="text-right">₹{(Number(item.product_price) * 0.09).toFixed(2)}</td>
                    <td>9%</td>
                    <td className="text-right">₹{(Number(item.product_price) * 0.09).toFixed(2)}</td>
                    <td className="text-right fw-bold">₹{(Number(item.product_price) * 1.18).toFixed(2)}</td>
                  </tr>
                ))}
                <tr className="totals-row">
                  <td colspan="4">Total Items: {order.items.length}</td>
                  <td colspan="4"></td>
                  <td className="text-right fw-bold">₹{Number(order.vendor_total).toLocaleString()}</td>
                  <td></td>
                  <td className="text-right">₹{(Number(order.vendor_total) * 0.09).toFixed(2)}</td>
                  <td></td>
                  <td className="text-right">₹{(Number(order.vendor_total) * 0.09).toFixed(2)}</td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Totals Section */}
          <div className="totals-section">
            <div className="totals-left">
              <div className="total-words">
                <p className="fw-bold">Total Amount (in words):</p>
                <p>{order.vendor_total === 1 ? "One" : order.vendor_total} Rupee(s)</p>
              </div>
            </div>
            <div className="totals-right">
              <table className="summary-table">
                <tr>
                  <td className="label">Taxable Value</td>
                  <td className="value">₹{Number(order.vendor_total).toLocaleString()}</td>
                </tr>
                <tr>
                  <td className="label">SGST @ 9%</td>
                  <td className="value">₹{(Number(order.vendor_total) * 0.09).toFixed(2)}</td>
                </tr>
                <tr>
                  <td className="label">CGST @ 9%</td>
                  <td className="value">₹{(Number(order.vendor_total) * 0.09).toFixed(2)}</td>
                </tr>
                <tr>
                  <td className="label">Total Tax Amount</td>
                  <td className="value">₹{(Number(order.vendor_total) * 0.18).toFixed(2)}</td>
                </tr>
                <tr className="grand-total">
                  <td className="label">Grand Total</td>
                  <td className="value">₹{(Number(order.vendor_total) * 1.18).toFixed(2)}</td>
                </tr>
              </table>
            </div>
          </div>

          {/* Additional Details */}
          <div className="additional-details">
            <div className="details-left">
              <h4 className="detail-heading">E-COMMERCE OPERATOR DETAILS</h4>
              <p><strong>Name :</strong> Subcity International Marketing Pvt Ltd</p>
              <p><strong>GSTIN/UIN :</strong> 18AABCS1234M1ZP</p>
              <p><strong>Address :</strong> Paliguri, Jagiroad, Morigaon, Assam - 782410, India</p>
              <p><strong>E-Mail :</strong> support@subcity.in</p>
              <p><strong>Contact No. :</strong> 8876499739</p>

              <h4 className="detail-heading mt-4">BANK DETAILS</h4>
              <p><strong>Bank Name :</strong> State Bank of India</p>
              <p><strong>A/c Name :</strong> Subcity International marketing Pvt Ltd</p>
              <p><strong>A/c No. :</strong> 20510534705</p>
              <p><strong>IFSC Code :</strong> SBIN0002068</p>
              <p><strong>Branch :</strong> Jagiroad</p>
            </div>

            <div className="details-right">
              <h4 className="detail-heading">TRANSPORT DETAILS</h4>
              <p><strong>Courier Partner :</strong> Amazon Transportation Services</p>
              <p><strong>AWB / Tracking No. :</strong> 12345678901</p>
              <p><strong>Date of Dispatch :</strong> {formatDate(order.created_at)}</p>

              <h4 className="detail-heading mt-4">PAYMENT DETAILS</h4>
              <p><strong>Payment Mode :</strong> {order.payment_method?.toUpperCase() || 'ONLINE'}</p>
              <p><strong>Amount Received :</strong> ₹{(Number(order.vendor_total) * 1.18).toFixed(2)}</p>
              <p><strong>Transaction ID :</strong> COD-{order.order_id}</p>
              <p><strong>Date :</strong> {formatDate(order.created_at)}</p>

              <div className="signature-section">
                <p className="fw-bold mt-4">For Subcity International Marketing Pvt Ltd</p>
                <div className="signature-placeholder">Signature</div>
                <p className="fw-bold">Authorised Signatory</p>
                {/* <div className="seal-placeholder">SEAL</div> */}
              </div>
            </div>
          </div>

          {/* Terms & Conditions */}
          <div className="terms-section">
            <h4 className="section-header">TERMS & CONDITIONS</h4>
            <div className="terms-content">
              <ol>
                <li>This is a computer generated invoice and does not require physical signature.</li>
                <li>Goods once sold will not be taken back or exchanged.</li>
                <li>Warranty, if any, will be as per manufacturer / brand policy.</li>
                <li>Goods are dispatched after proper quality check.</li>
                <li>Any disputes are subject to Jurisdiction of Courts in Assam only.</li>
                <li>Device/Accessories need to be returned in original packaging along with all accessories, invoice & warranty card.</li>
                <li>E & O E</li>
              </ol>
            </div>

            <h4 className="section-header mt-3">IMPORTANT NOTES</h4>
            <div className="important-notes">
              <ul>
                <li>Please retain this invoice for warranty and future reference.</li>
                <li>Visit www.subcity.in for return and refund policy.</li>
                <li>For any queries, contact our support team.</li>
              </ul>
              <div className="tax-notice">
                <p>This is a Tax Invoice issued under the provisions of CGST Act, 2017 and IGST Act, 2017.</p>
              </div>
            </div>
          </div>

          {/* Footer */}
          <div className="invoice-footer">
            <div className="footer-content">
              <span>📞 8876499739</span>
              <span>📧 support@subcity.in</span>
              <span>🌐 www.subcity.in</span>
            </div>
          </div>
        </div>
      </main>

      <style>{`
        .invoice-container {
          max-width: 900px;
          margin: 0 auto;
          background: white;
          padding: 20px;
          font-family: 'Arial', sans-serif;
          color: #333;
          border: 1px solid #e0e0e0;
          box-shadow: 0 2px 8px rgba(0,0,0,0.1);
        }

        .printable-section {
          page-break-after: always;
        }

        /* Header */
        .invoice-header {
          display: grid;
          grid-template-columns: 1fr 1.5fr 1.5fr;
          gap: 20px;
          margin-bottom: 20px;
          border-bottom: 2px solid #003d82;
          padding-bottom: 15px;
          align-items: center;
        }

        .logo-section {
          text-align: center;
        }

        .company-name {
          font-size: 28px;
          font-weight: bold;
          color: #003d82;
          margin: 0;
        }

        .tagline {
          font-size: 11px;
          color: #d32f2f;
          margin: 3px 0 0 0;
          font-weight: bold;
        }

        .invoice-title {
          font-size: 24px;
          font-weight: bold;
          color: #003d82;
          text-align: center;
          margin: 0;
        }

        .invoice-subtitle {
          font-size: 12px;
          text-align: center;
          margin: 3px 0;
          font-weight: bold;
        }

        .invoice-note {
          font-size: 10px;
          text-align: center;
          margin: 0;
          color: #666;
        }

        .invoice-meta-table {
          width: 100%;
          border-collapse: collapse;
          font-size: 11px;
        }

        .invoice-meta-table td {
          border: 1px solid #ccc;
          padding: 6px;
        }

        .invoice-meta-table .label {
          background-color: #f0f0f0;
          font-weight: bold;
          width: 50%;
        }

        .invoice-meta-table .value {
          text-align: center;
        }

        /* Billing Section */
        .billing-section {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 20px;
          margin-bottom: 20px;
          border: 1px solid #ccc;
        }

        .billing-from, .shipment-from {
          padding: 15px;
          border-right: 1px solid #ccc;
        }

        .shipment-from {
          border-right: none;
        }

        .section-header {
          background-color: #003d82;
          color: white;
          padding: 8px 12px;
          margin: -15px -15px 12px -15px;
          font-size: 12px;
          font-weight: bold;
          text-transform: uppercase;
        }

        .qr-section {
          text-align: center;
          margin-bottom: 15px;
        }

        .qr-placeholder {
          display: inline-block;
          border: 1px solid #ccc;
          padding: 5px;
        }

        .billing-details, .shipment-details {
          font-size: 11px;
          line-height: 1.1;
        }

        .billing-details p, .shipment-details p {
          margin: 4px 0;
        }

        /* Customer Section */
        .customer-section {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 20px;
          margin-bottom: 20px;
          border: 1px solid #ccc;
        }

        .billed-to, .shipped-to {
          padding: 15px;
          border-right: 1px solid #ccc;
        }

        .shipped-to {
          border-right: none;
        }

        .customer-details {
          font-size: 11px;
          line-height: 1.1;
        }

        .customer-details p {
          margin: 4px 0;
        }

        /* Invoice Details */
        .invoice-details {
          padding: 8px 15px;
          background-color: #f9f9f9;
          border: 1px solid #ccc;
          font-size: 11px;
          margin-bottom: 20px;
        }

        /* Items Table */
        .items-table {
          margin-bottom: 20px;
          overflow-x: auto;
        }

        .items-table table {
          width: 100%;
          border-collapse: collapse;
          font-size: 10px;
        }

        .items-table th {
          background-color: #f0f0f0;
          border: 1px solid #ccc;
          padding: 8px;
          font-weight: bold;
          text-align: center;
        }

        .items-table td {
          border: 1px solid #ccc;
          padding: 8px;
          text-align: right;
        }

        .items-table td.item-name {
          text-align: left;
        }

        .items-table td.text-center {
          text-align: center;
        }

        .items-table td.text-right {
          text-align: right;
        }

        .item-variant {
          font-size: 9px;
          color: #999;
          display: block;
          margin-top: 2px;
        }

        .totals-row {
          background-color: #f9f9f9;
          font-weight: bold;
        }

        /* Totals Section */
        .totals-section {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 20px;
          margin-bottom: 20px;
        }

        .totals-left {
          padding: 15px;
          border: 1px solid #ccc;
          background-color: #f9f9f9;
        }

        .total-words {
          font-size: 11px;
        }

        .total-words p {
          margin: 4px 0;
        }

        .totals-right {
          padding: 0;
        }

        .summary-table {
          width: 100%;
          border-collapse: collapse;
          font-size: 11px;
        }

        .summary-table tr {
          border: 1px solid #ccc;
        }

        .summary-table td {
          padding: 8px;
          border-right: 1px solid #ccc;
        }

        .summary-table td:last-child {
          border-right: none;
        }

        .summary-table .label {
          background-color: #f0f0f0;
          font-weight: bold;
          width: 50%;
        }

        .summary-table .value {
          text-align: right;
          font-weight: bold;
        }

        .summary-table .grand-total {
          background-color: #003d82;
          color: white;
        }

        .summary-table .grand-total .label,
        .summary-table .grand-total .value {
          color: white;
        }

        /* Additional Details */
        .additional-details {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 20px;
          margin-bottom: 20px;
        }

        .details-left, .details-right {
          font-size: 10px;
          line-height: 1.1;
        }

        .detail-heading {
          background-color: #003d82;
          color: white;
          padding: 8px 12px;
          margin: 0 0 12px 0;
          font-size: 11px;
          font-weight: bold;
        }

        .details-left p, .details-right p {
          margin: 4px 0;
        }

        .signature-section {
          margin-top: 30px;
          text-align: center;
        }

        .signature-placeholder, .seal-placeholder {
          height: 40px;
          border: 1px dashed #ccc;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 10px;
          color: #999;
          margin: 8px 0;
        }

        /* Terms Section */
        .terms-section {
          margin-bottom: 20px;
          border: 1px solid #ccc;
          padding: 15px;
        }

        .terms-content, .important-notes {
          font-size: 10px;
          line-height: 1.1;
          margin-top: 8px;
        }

        .terms-content ol, .important-notes ul {
          margin: 0;
          padding-left: 20px;
        }

        .terms-content li, .important-notes li {
          margin-bottom: 4px;
        }

        .tax-notice {
          background-color: #fff3cd;
          border: 1px solid #ffeaa7;
          padding: 10px;
          margin-top: 10px;
          border-radius: 4px;
          font-size: 10px;
          font-weight: bold;
          text-align: center;
        }

        /* Footer */
        .invoice-footer {
          background-color: #003d82;
          color: white;
          padding: 15px;
          text-align: center;
          font-size: 11px;
          border-radius: 4px;
          margin-top: 20px;
        }

        .footer-content {
          display: flex;
          justify-content: center;
          gap: 30px;
          flex-wrap: wrap;
        }

        .footer-content span {
          font-weight: bold;
        }

        /* Print Styles */
        @media print {
          body * {
            visibility: hidden;
          }
          .printable-section,
          .printable-section * {
            visibility: visible;
          }
          .printable-section {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            box-shadow: none;
            border: none;
            page-break-after: always;
          }
          .d-print-none {
            display: none !important;
          }
          .main-wrapper {
            background-color: white !important;
            padding: 0 !important;
          }
          .invoice-container {
            box-shadow: none;
            border: none;
            padding: 0;
            max-width: 100%;
          }
        }

        @media (max-width: 768px) {
          .invoice-header {
            grid-template-columns: 1fr;
          }

          .billing-section,
          .customer-section,
          .additional-details,
          .totals-section {
            grid-template-columns: 1fr;
          }

          .billing-from, .shipment-from,
          .billed-to, .shipped-to,
          .details-left, .details-right {
            border-right: none;
            border-bottom: 1px solid #ccc;
          }

          .items-table {
            font-size: 8px;
          }

          .items-table th,
          .items-table td {
            padding: 4px;
          }
        }
      `}</style>
    </>
  );
}

export default Invoice;